<template>
    <div class="interetForm">
        <Header :code="code">Reprise</Header>
        <v-container>
            <v-row>
                <v-col cols="12" class="formCol">
                    <v-text-field v-model="interet.marque" :label="$t('messages.reprise.marque')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-text-field v-model="interet.modele" :label="$t('messages.reprise.modele')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-select v-model="interet.carburant" :items="energieItems" :label="$t('messages.reprise.energie')" hide-details></v-select>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-select v-model="interet.boite_de_vitesse" :items="boiteItems" :label="$t('messages.reprise.boite')" hide-details></v-select>
                </v-col>
                 <v-col cols="12" class="formCol">
                    <v-text-field v-model="interet.budget" :label="$t('messages.reprise.budget')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="btnGroup">
                    {{$t('messages.reprise.financement_prevu')}}
                    <v-btn-toggle    
                    v-model="interet.financement"                          
                    tile
                    color="primary"
                    dense
                    mandatory
                    group
                    >
                        <v-btn :value="null">
                            {{$t('messages.todo.nc')}}
                        </v-btn>
                        <v-btn :value="true">
                            {{$t('messages.todo.oui')}}
                        </v-btn>
                        <v-btn :value="false">
                            {{$t('messages.todo.non')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col cols="12" class="btnGroup">
                    {{$t('messages.reprise.vo_vn_vd')}}
                    <v-btn-toggle    
                    v-model="interet.vo_vn_vd"                          
                    tile
                    color="primary"
                    dense
                    mandatory
                    group
                    >
                        <v-btn :value="null">
                            {{$t('messages.todo.nc')}}
                        </v-btn>
                        <v-btn value="VO">
                            VO
                        </v-btn>
                        <v-btn value="VN">
                            VN
                        </v-btn>
                        <v-btn value="VD">
                            VD
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        name="input-7-1"
                        label="Commentaire"
                        v-model="interet.description"
                        hide-details 
                    ></v-textarea>
                </v-col>
                <v-col cols="12" v-if="mode == 'create'" class="btnGroup btns">
                    <v-btn dark depressed color="grey" @click="$router.push(-1)">Annuler</v-btn>
                    <v-btn depressed color="primary" @click="createInteret">Enregistrer</v-btn>
                </v-col>
                <v-col cols="12" v-if="mode == 'edit'" class="btnGroup btns">
                    <v-btn dark depressed color="grey" @click='deleteConfirm = true'>Supprimer</v-btn>
                    <v-btn depressed color="primary" @click="modifyReprise">Modifier</v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
        v-model="deleteConfirm"
        persistent
        max-width="290"
        >
            <v-card>
                <v-card-title class="">
                Êtes-vous sûr de vouloir effacer le véhicule ?
                </v-card-title>
                <v-card-text>Ceci est une action irréversible.</v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="grey darken-1"
                    text
                    @click="deleteConfirm = false"
                >
                    Annuler
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="deleteInteret">
                    Effacer
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Header from '@/components/Header'
export default {
    name:"InteretForm",
    props: ['code', 'id', 'mode'],
    components: {
        Header
    },
    data() {
        return {
            projet: {},
            lead: {},
            interetToModify: {},
            energieItems: ["Diesel", "Essence", "Hybride", "Electrique"],
            boiteItems: ["Manuelle", "Automatique"],
            deleteConfirm:false,
            interet: {
                type:"INTERET",
                marque:"",
                modele:"",
                carburant:"",
                boite_de_vitesse: "",
                budget:"",
                description:"",
                financement:"",
                vo_vn_vd: "",
            }
        } 
    },
    methods: {
        createInteret(){
            const payload = {
                code_lead: this.lead.code_lead,
                id_utilisateur: this.$store.state.user.id,
                data: this.interet
            }
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('addVehicule', payload).then((e) => {
                    this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                        this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                    })
                })
            })
        },
        modifyReprise(){
            const payload = {
                id_vehicule: this.interetToModify.id,
                id_utilisateur: this.$store.state.user.id,
                data: this.interet
            }
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('modifyVehicule', payload).then((e) => {
                    this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                        this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                    })
                })
            })
        },
        deleteInteret(){
            const payload = {
                id_vehicule: this.interetToModify.id,
                id_utilisateur: this.$store.state.user.id,
            }
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('deleteVehicule', payload).then((e) => {
                    this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                        this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                    })
                })
            })
        }
    },
    created() {
        if(Object.keys(this.$store.state.detailLead).length === 0 || Object.keys(this.$store.state.leads).length === 0){
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    const lead = this.$store.state.leads.find(e => e.id == this.id);
                    this.$store.dispatch('getDetailLead', lead.code_lead).then((e) => {
                        this.$store.dispatch('setLoader', false)
                        this.lead = this.$store.state.leads.find(e => e.id == this.id);
                        this.projet = this.$store.state.projets.find((e) => {
                            return e.code_projet == this.code
                        })
                        if(this.$store.state.loader){
                            this.$store.dispatch('setLoader', false)
                        }
                        if(this.mode == "edit"){
                            this.interetToModify = this.$store.state.detailLead.vehicules.find((e) => e.type == "INTERET");
                            this.interet.marque = this.interetToModify.marque,
                            this.interet.modele = this.interetToModify.modele,
                            this.interet.budget = this.interetToModify.budget,
                            this.interet.carburant = this.interetToModify.energie,
                            this.interet.boite_de_vitesse = this.interetToModify.boite,
                            this.interet.description = this.interetToModify.commentaire
                            //financement
                            if(this.interetToModify.financement === null || this.interetToModify.financement === 0){
                                this.interet.financement = null
                            }else if(this.interetToModify.financement === "NON"){
                                this.interet.financement = false
                            }else if(this.interetToModify.financement === "OUI"){
                                this.interet.financement = true
                            }
                            if(this.interetToModify.etat === null || this.interetToModify.etat === 0){
                                this.interet.vo_vn_vd = null
                            } else {
                                this.interet.vo_vn_vd = this.interetToModify.etat 
                            }
                        }
                    }) 
                })                
            })
        } else {
            this.lead = this.$store.state.leads.find(e => e.id == this.id);
            this.projet = this.$store.state.projets.find((e) => {
                return e.code_projet == this.code
            })
            if(this.$store.state.loader){
                this.$store.dispatch('setLoader', false)
            }
            if(this.mode == "edit"){
                this.interetToModify = this.$store.state.detailLead.vehicules.find((e) => e.type == "INTERET");
                this.interet.marque = this.interetToModify.marque,
                this.interet.modele = this.interetToModify.modele,
                this.interet.budget = this.interetToModify.budget,
                this.interet.carburant = this.interetToModify.energie,
                this.interet.boite_de_vitesse = this.interetToModify.boite,
                this.interet.description = this.interetToModify.commentaire
                //financement
                if(this.interetToModify.financement === null || this.interetToModify.financement === 0){
                    this.interet.financement = null
                }else if(this.interetToModify.financement === "NON"){
                    this.interet.financement = false
                }else if(this.interetToModify.financement === "OUI"){
                    this.interet.financement = true
                }
                if(this.interetToModify.etat === null || this.interetToModify.etat === 0){
                    this.interet.vo_vn_vd = null
                } else {
                    this.interet.vo_vn_vd = this.interetToModify.etat 
                }
            }
        }
        
    },
}
</script>
<style lang="scss">
    .interetForm {
        padding-top:8vh;

        .btnGroup  {
            display:flex;
            align-items: center;
            justify-content: space-between;
            padding: 4px 12px;
            margin-top:4px;
            .v-btn {
                margin:0;
            }
        }
    }

</style>